<template>
  <v-card>
    <v-card-title class="d-flex align-center">Removed Users</v-card-title>
    <v-card-subtitle>
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field
            v-model.trim="search"
            append-icon="search"
            label="Search by email or company"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-subtitle>

    <v-data-table
      :server-items-length="totalAmount"
      :loading="loading"
      :headers="headers"
      :items="users"
      class="elevation-1"
      :footer-props="{
        'items-per-page-options': $options.DEFAULT_ITEMS_PER_PAGE_OPTIONS,
      }"
      fixed-header
      :options.sync="options"
    >
      <template v-slot:[`item.email`]="{ item }">
        <router-link :to="{ name: 'User', params: { id: item.id } }">{{
          item.email
        }}</router-link>
      </template>
      <template v-slot:[`item.companyName`]="{ item }">
        <span
          v-if="item.companyName && item.companyName.length > truncateLength"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{
                truncateText(item.companyName, truncateLength)
              }}</span>
            </template>
            <span>{{ item.companyName }}</span>
          </v-tooltip>
        </span>
        <span v-else>
          {{ item.companyName }}
        </span>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ formatDate(item.createdAt) }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-chip :color="item.status === 'blocked' ? 'red' : 'grey'" dark small>
          {{ statuses.find((status) => status.value === item.status).text }}
        </v-chip>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import {
  DEFAULT_ITEMS_PER_PAGE_OPTIONS,
  DEFAULT_ITEMS_PER_PAGE,
} from "../../constants";
import { loginAsCustomer, formatDate, truncateText } from "../../helpers";
import { API } from "../../api";

export default {
  name: "RemovedUsersTable",
  DEFAULT_ITEMS_PER_PAGE_OPTIONS,
  data() {
    return {
      formatDate,
      loginAsCustomer,
      truncateText,
      truncateLength: 30,
      timerId: null,
      DEFAULT_ITEMS_PER_PAGE_OPTIONS,
      DEFAULT_ITEMS_PER_PAGE,
      users: [],
      loading: false,
      totalAmount: 0,
      search: "",
      options: {
        page: 1,
        itemsPerPage: DEFAULT_ITEMS_PER_PAGE,
        sortBy: ["createdAt"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false,
      },
      headers: [
        {
          text: "Email",
          align: "start",
          sortable: true,
          value: "userEmail",
          width: "200",
        },
        { text: "Company", value: "companyName", sortable: true, width: "200" },
        {
          text: "Deleted at",
          value: "createdAt",
          sortable: true,
          width: "200",
        },
        { text: "Status", value: "status", width: "150" },
      ],
      statuses: [
        { text: "Blocked", value: "blocked" },
        { text: "Deleted", value: "deleted" },
      ],
    };
  },
  watch: {
    search: {
      handler: "debounceFetching",
    },
    options: {
      handler: "debounceFetching",
      deep: true,
    },
  },
  methods: {
    debounceFetching() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }

      this.timerId = setTimeout(() => {
        this.getRemovedUsers();
      }, 500);
    },
    async getRemovedUsers() {
      this.loading = true;
      try {
        const users = await API.getRemovedUsers({
          sortBy: this.options.sortBy[0],
          order: this.options.sortDesc[0] ? "desc" : "asc",
          page: this.options.page,
          pageSize:
            this.options.itemsPerPage === -1 ? 0 : this.options.itemsPerPage,
          query: this.search === "" ? null : this.search,
        });
        this.users = users.data;
        this.totalAmount = users.count;
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>
